import { memo, ReactElement } from 'react'

import NavbarMenuItems, { MenuItem } from './navBarItems'

import './index.css'

type NavbarProps = {
  menuItems: MenuItem[]
}
const Navbar = (props: NavbarProps): ReactElement => (
  <nav className="navbar-homepage" aria-label="main navbar">
    <NavbarMenuItems items={props.menuItems} />
  </nav>
)

export default memo(Navbar)
